import React from "react";
import Events from "../components/Events.jsx";
import { Box } from "@mui/material";

const Dashboard = () => {
  return (
    <Box>
      <Events />
    </Box>
  );
};

export default Dashboard;
